/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { getSupplyPhenology } from "../../funcs/getSupplyPhenology.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSupplyPhenologyRequest$inboundSchema,
};

export const tool$getSupplyPhenology: ToolDefinition<typeof args> = {
  name: "get-supply-phenology",
  description:
    `Get phenology stages information for a crop and country and or region

Returns the month day of the beginning and end of phenology stages for a given crop and region`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await getSupplyPhenology(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
